import React from 'react';

import { ReactComponent as EnergyEntry } from 'assets/pics/energy_entry.svg';
import { ReactComponent as GasEntry } from 'assets/pics/gas_entry.svg';
import PropTypes from 'prop-types';

const BranchValueLine = ({ icon, branch, companyType }) => (
  <div className="installer-statusbar__line installer-statusbar__line--branch">
    <span className="installer-statusbar__field-value" data-label="Sparte">
      <span className="installer-statusbar__table-row-branch">
        {icon}
        <span>{branch}</span>
      </span>
    </span>
    <span className="installer-statusbar__field-value" data-label="Tätigkeitsschwerpunkt">
      {companyType}
    </span>
  </div>
);

BranchValueLine.propTypes = {
  icon: PropTypes.node.isRequired,
  branch: PropTypes.string.isRequired,
  companyType: PropTypes.string,
};

BranchValueLine.defaultProps = {
  companyType: '',
};

export const FachinteressentStatusbarContent = ({ id, energyEntry, gasEntry }) => {
  if (!id && !energyEntry && !gasEntry) {
    return null;
  }

  const hasBranches = energyEntry || gasEntry;

  return (
    <div className="installer-statusbar__overview">
      {id && (
        <div className="installer-statusbar__line">
          <div className="installer-statusbar__field">
            <span className="installer-statusbar__field-label">Registrierungsnummer</span>
            <span className="installer-statusbar__field-value">{id}</span>
          </div>
        </div>
      )}
      {hasBranches && (
        <div className="installer-statusbar__line installer-statusbar__line--branch">
          <span className="installer-statusbar__field-label">Sparte</span>
          <span className="installer-statusbar__field-label">Tätigkeitsschwerpunkt</span>
        </div>
      )}
      {energyEntry && (
        <BranchValueLine
          {...energyEntry}
          icon={<EnergyEntry width={30} height={30} />}
        />
      )}
      {gasEntry && (
        <BranchValueLine
          {...gasEntry}
          icon={<GasEntry width={30} height={30} />}
        />
      )}
    </div>
  );
};

FachinteressentStatusbarContent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  energyEntry: PropTypes.shape({
    branch: PropTypes.string,
    companyType: PropTypes.string,
  }),
  gasEntry: PropTypes.shape({
    branch: PropTypes.string,
    companyType: PropTypes.string,
  }),
};

FachinteressentStatusbarContent.defaultProps = {
  id: undefined,
  energyEntry: undefined,
  gasEntry: undefined,
};
